
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    ORTIRON_ACTION,
    ALL_ORTIRON,
    ADD_ORTIRON,
    FETCH_ORTIRON,
    EDIT_ORTIRON,
    DELETE_ORTIRON,
    FETCH_ORTIRONCHART,
    FETCH_ORTIRONSHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Range Iron Test Actions
 */

    export const allORTIronTest = () =>{    
        
        return (dispatch) => { 
            dispatch({ type: ORTIRON_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getonriron', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTIRON, payload: alldata });
            });
        }        

    }

    export const studentORTIronTest = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:ORTIRON_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentonriron', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTIRON, payload: alldata }); 
            });
        
        }
    }

    export const addORTIronTest = (data, sepmore) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {        
            
            var shot='distance_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var shotadd='distance_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;            
    
        }        

        return (dispatch) => { 
            dispatch({ type:ORTIRON_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addonriron', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTIronTest(stdid, start, end)(dispatch);
                    var distance='';
                    var area='';
                    var contact='';
                    fetchORTIronReport(stdid, start, end, distance, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_ORTIRON});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchORTIronTest = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:ORTIRON_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getonrirondetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_ORTIRON, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editORTIronTest = (data, sepmore, oldate) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
            "olddate":oldate,
        }

        for (let i = 0; i<sepmore; i++) {        
            
            var shot='distance_'+i;            
            var shotval=data.target[shot].value;
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var shotadd='distance_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            
            payload[shotadd]=shotval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;            
    
        }

        return (dispatch) => { 
            dispatch({ type:ORTIRON_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editonriron', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTIronTest(stdid, start, end)(dispatch);
                    var distance='';
                    var area='';
                    var contact='';
                    fetchORTIronReport(stdid, start, end, distance, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_ORTIRON});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deleteORTIronTest = (id, date) =>{
        
        var payload={
            "id":id,
            "date":date
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTIRON_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteonriron', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTIronTest(id, start, end)(dispatch);
                    var distance='';
                    var area='';
                    var contact='';
                    fetchORTIronReport(id, start, end, distance, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_ORTIRON});                    
                }                
                
            });
        
        }
    }

    export const fetchORTIronReport = (id, start, end, distance, area, contact) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "distance":distance,
            "contact":contact,
            "area":area,         
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTIRON_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangeironreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTIRONCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);               
                
            });
        
        }
    }

    export const fetchORTIronShotChart = (id, start, end, distance, area, contact, val) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "distance":distance,
            "contact":contact,
            "area":area,
            "section":val            
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTIRON_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangeironshotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTIRONSHOTCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);               
                
            });
        
        }
    }

